import { match, P } from "ts-pattern"
import * as F from "fp-ts/function"
import * as ROA from "fp-ts/ReadonlyArray"
import { httpDataLoadMachine } from "../../../../../_common/machines/http-data-load-machine"
import { httpDataLoadTypes } from "../../../../../_common/machines/http-data-load-machine.types"
import { CruisePaymentTermsResponse } from "../../../../../_common/dot-com-api-types"
import { ECommerceEvent } from "../e-commerce-machine"

const types = httpDataLoadTypes(CruisePaymentTermsResponse)
export type PaymentTermsLoaderTypes = typeof types
type Context = PaymentTermsLoaderTypes["Context"]
type Events = PaymentTermsLoaderTypes["Events"]

const notifyParent = (ctx: Context, ev: Events) =>
    match<Events, ECommerceEvent | undefined>(ev)
        .with({ type: "LOAD_COMPLETED", successes: P.when((x) => x.length > 0) }, cruisePaymentTermsLoaded)
        .otherwise(() => notifyError(ctx))

export const buildCruisePaymentTermsLoader = () =>
    httpDataLoadMachine({
        id: "cruise-payment-terms",
        Success: CruisePaymentTermsResponse,
        notifyParent,
    })

const cruisePaymentTermsLoaded = (ev: PaymentTermsLoaderTypes["LoadCompleted"]) => {
    if (ev.failures.length > 0) {
        const data = {
            failures: F.pipe(
                ev.failures,
                ROA.map((failure) => {
                    if (failure instanceof Error) return { message: failure.message, stack: failure.stack }
                    return { message: "HTTP error", status: failure.status, statusText: failure.statusText }
                }),
            ),
        }
        console.warn("Unable to load cruise payment terms", data)
        window.rollbar?.warning("Unable to load cruise payment terms", data)
    }
    return {
        type: "CRUISE_PAYMENT_TERMS_LOADED" as const,
        response: ev.successes,
    }
}

const notifyError = (ctx: Context) => ({
    type: "ERROR" as const,
    kind: "generic" as const,
    origin: ctx.id,
    errorCode: "http" as const,
    info: undefined,
    message: "Load error cruise-payment-terms",
})
